import AuthContext from "context/AuthContext";
import { useEffect } from "react";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGet } from "utils/apiFetch";
import apiPath from "utils/apiPath";

function TestManager() {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const [tests, setTests] = useState([]);

  useEffect(() => {
    async function fetchTests() {
      const path = apiPath.quizTests;

      const result = await apiGet(path);
      setTests(result?.data?.results);
      console.log(result?.data?.results);
    }
    fetchTests();
  }, []);

  return (
    <div className="pb-3">
      <h1>Test Manager</h1>
    </div>
  );
}

export default TestManager;
